import React from 'react';
import PlacesAutocomplete from 'react-places-autocomplete';
import Carousel from './../../../components/Carousel/Carousel';
import Aux from './../../../hoc/_Aux';
import Birthday from './../../../components/Birthday/Birthday';

//import './../../../css/placesAutoComplete.css';

const Input = ( props ) => {
    let inputElement = null;

    switch ( props.elementType ) {
        case 'input':
            let checkboxDefaultChecked = {}
            if(props.elementConfig.type==='checkbox'){
                checkboxDefaultChecked = {'defaultChecked': false};
            }

            if(props.elementConfig.type==='date'){
                inputElement = (<Birthday classes={props.classes} onChange={props.changed} birthdayDate={props.value!==""?props.value:null} />);
            }else{

                inputElement = <input
                    className={props.classes.join(' ')}
                    {...props.elementConfig}
                    {...checkboxDefaultChecked}
                    value={props.value}
                    onChange={props.changed} 
                    />;
            }

            break;
        case 'textarea':
            inputElement = <textarea
                //className={props.classes.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
            break;
        case 'select':
            inputElement = (
                <select
                    //className={props.classes.join(' ')}
                    value={props.value}
                    onChange={props.changed}>
                    {props.elementConfig.options.map(option => (
                        <option key={option.value} value={option.value}>
                            {option.displayValue}
                        </option>
                    ))}
                </select>
            );
            break;
        case 'avatar':
            const w = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            let wSlider = 125;

            if ( w < 375 ) 
              wSlider = Math.floor(w / 3);

            const carouselContainerStyle = {
              marginLeft: -wSlider+10
            }
            
            inputElement = (
                <div className="avatar" style={carouselContainerStyle} >
                  <Carousel 
                    onChange={props.changed}
                    slideWidth={wSlider} 
                    slideHeight={wSlider}
                    selectedAvatarNumber={props.value} >
                    { props.options.images.map((image, index) =>  
                        <img key={index} src={image} alt={`avatar ${index}`} />
                    )}
                    <input name="avatar" type="hidden" value='0'/>
                   </Carousel>
                </div>
            )
            break;
        case 'PlaceAutocomplete':
            const inputProps = {
                value: props.value,
                onChange: props.changedPlacesAutoComplete,
                placeholder: props.elementConfig.placeholder
            }
            inputElement = <PlacesAutocomplete inputProps={inputProps} options={props.options} />
            break;
        default:
            inputElement = <input
                //className={props.classes.join(' ')}
                {...props.elementConfig}
                value={props.value}
                onChange={props.changed} />;
    }

    let label = (props.label);
    if(    typeof props.options !== 'undefined' 
        && typeof props.options.obj !== 'undefined'
        && typeof props.options.labelHandler !== 'undefined' 
        && typeof props.options.labelHandlerOn !== 'undefined')
    {
        const startingPositionHandler = props.label.indexOf(props.options.labelHandlerOn);
        if(startingPositionHandler !== -1)
        {
            const stringArray = props.label.split(props.options.labelHandlerOn);
            label = (
                <Aux>
                    {stringArray[0]}
                    <span className="label-event" onClick={props.options.labelHandler.bind(props.options.obj)}>{props.options.labelHandlerOn}</span>
                    {typeof stringArray[1] !== 'undefined'?stringArray[1]:''}
                </Aux>
            );
        }
    }

    return (
        <div className={`${props.elementType}-group${props.elementConfig.type==='checkbox'?'-ckb':''}`}>
            {(typeof props.title !== 'undefined' && props.title !== '')?<span className={`label-row ${props.name}`}>{props.title}</span>:''}
            {(props.labelPosition !== '' && props.labelPosition ==='left')?<label className="left-pos">{label}</label>:''}
            {inputElement}
            {(props.labelPosition !== '' && props.labelPosition ==='right')?<label className="right-pos">{label}</label>:''}
        </div>
    );

};

export default Input;


// WEBPACK FOOTER //
// ./src/containers/UI/Input/Input.js